@if (showLoader()) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}
<app-header></app-header>
<div class="container relative height-100vh">
  <div class="inner-content-wrap">
    <div class="login">
      <h1 class="farro-header mb8">{{welcomeHeading}}</h1>
      <p class="mb44 mb32-1100">{{enterEmail}}</p>
      <div class="login-field mb24">
        <form [formGroup]="signInFormGroup">
          @for (question of questions; track question) {
            <div>
              @if (question.mappingField === 'primary_email') {
                <div>
                  <label for="email" class="label-txt">{{question.label}}</label>
                  <mat-form-field>
                    <input [ngClass]="{'input-error':(this.signInFormGroup.get('emailAddress')?.hasError('required')|| this.signInFormGroup.get('emailAddress')?.hasError('pattern'))&&submitted}" matInput placeholder="{{question.defaultValue}}" id="email"
                      formControlName="emailAddress">
                  </mat-form-field>
                  @if ((signInFormGroup.get('emailAddress')?.hasError('required') || signInFormGroup.get('emailAddress')?.hasError('pattern')) && submitted) {
                    <div class="reg-err"
                      >
                    {{question.helpText}}</div>
                  }
                </div>
              }
            </div>
          }
        </form>
      </div>
      <div class="login-btn-cnr">
        <button class="login-btn" (click)="nextpage()" id="signinNext">{{nextButton}}</button>
      </div>
    </div>
  </div>
</div>